import script from "./InsuranceManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InsuranceManagement.vue?vue&type=script&setup=true&lang=js"

import "./InsuranceManagement.vue?vue&type=style&index=0&id=0d9c3982&lang=css"

const __exports__ = script;

export default __exports__